import React, { Fragment, useEffect, useState } from "react";
import Header from "../Components/Reuseable/Header";
import Auth from "../Components/Reuseable/Auth";
import "../../Webiste/Components/CSS/pagesCSS/dashboard.css";
import Search from "../Components/Home/Components/Search";
import Tracker from "../Components/Home/Components/Tracker";
import Notification from "../Components/Home/Components/Notification";
import ExNews from "../Components/Home/Components/ExNews";
import Language from "../Components/Home/Components/Language";
import ScrollContainer from "react-indiana-drag-scroll";
import { useTranslation } from "react-i18next";
import { fetchsingleUser, STATUSES } from "../redux/getReducer/getSingleUser";
import { useDispatch, useSelector } from "react-redux";
import Lottie from "lottie-react";
import Animate from "../assets/loader.json";
import Cookies from "js-cookie";
import Moment from "react-moment";
import { Accordion } from "react-bootstrap";
import { fetchPointStaging } from "../redux/getReducer/getPointStagingSlice";
import axios from "axios";

import { getBaseUrl } from "../service/apiUrl";
const MySelection = () => {
  const { t } = useTranslation();
  const cookiedata = Cookies.get("i18next");
  const token = Cookies.get("token");
  const [CategorySub, setCategorySub] = useState();

  const dispatch = useDispatch();
  // const navigate = useNavigate();

  let getDataCategory = async () => {
    const tokencheck =
      token === undefined
        ? null
        : { Authorization: `Bearer ${token}` };

    if (!tokencheck) return;

    try {
      const res = await fetch(`${getBaseUrl()}/competition-v2/staging`, {
        headers: tokencheck,
      });
      if (res.status === 401) {
        // Explicit handling for Email Not Verified or Unauthorized
        setCategorySub([]);
        return;
      }
      const result = await res.json();
      setCategorySub(result?.data || []);
    } catch (err) {
      console.error("Error fetching staging data:", err);
      setCategorySub([]);
    }
  };

  useEffect(() => {
    getDataCategory();
  }, []);

  return (
    <Fragment>
      {/* <div className="d-flex">
        <Header />
        <Auth />
      </div> */}
      
      <div className="userHeader">
        <h3>{t("Competition Points And Staging")}</h3>
      </div>
      <div className="page">
        <div className="rightsidedata">
          <div
            style={{
              marginTop: "10px",
            }}
          ></div>
          <div className="PointsParent">
            {CategorySub ? (
              CategorySub.map((compItem, i) => {
                const races = compItem.CompetitionDataOfRaceV2 || compItem.CompetitionDataOfRaceV2 || [];
                return races.length > 0 ? (
                  <Accordion defaultActiveKey="0" key={i}>
                    <Accordion.Item eventKey={i.toString()}>
                      <div>
                        <Accordion.Header>
                          <div className="accordionHeader row">
                            <div className="headerCard1 col-sm-12">
                              {" "}
                              <h4>
                                {" "}
                                {cookiedata === "en"
                                  ? compItem.NameEn
                                  : compItem.NameAr}
                              </h4>{" "}
                            </div>{" "}
                          </div>
                        </Accordion.Header>
                        {/* <div className="row pointandstagings">
      <div className="col-sm-4">
        <h4>Race Name</h4>
      </div>
      <div className="col-sm-8 d-flex pointShown">
        <h5>Rank</h5>
        <h5>Bonus Point</h5>
        <h5>Points</h5>
   
      </div>
    </div> */}

                        {races.map((raceItem, j) => {
                          const pointTable = raceItem.PointTableOfRaceofRaceV2 || raceItem.PointTableOfRaceofRaceV2 || {};
                          const pointSystem = pointTable.PointSystemidDataOfCompetitionV2 || pointTable.PointSystemidDataOfCompetition || [];
                          return (
                              <Accordion.Body key={j}>
                                <div className="pointTable">
                                  <table>
                                    <thead>
                                      <tr>
                                        <th>Race Name</th>
                                        <th>Rank </th>
                                        <th>Points</th>
                                        <th>Bonus Points</th>
                                      </tr>
                                    </thead>

                                    {pointSystem.map(
                                        (pointItem, k) => {
                                          const raceData = pointItem.RaceDataOfCompetitionV2 || pointItem.RaceDataOfCompetitionV2;
                                          return (
                                            <tbody key={k}>
                                              <tr>
                                                <td>
                                                  {raceData && raceData.NameEn}
                                                </td>
                                                <td>{pointItem.Rank}</td>
                                                <td>{pointItem.BonusPoint}</td>
                                                <td>{pointItem.Point}</td>
                                              </tr>
                                            </tbody>
                                          );
                                        }
                                      )}
                                  </table>
                                </div>
                              </Accordion.Body>
                            );
                          })}
                      </div>
                    </Accordion.Item>
                  </Accordion>
                ) : null;
              })
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default MySelection;
